/* unplugin-vue-components disabled */import script from "./role-dialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./role-dialog.vue?vue&type=script&setup=true&lang=ts"

import "./role-dialog.vue?vue&type=style&index=0&id=49e1d6aa&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49e1d6aa"]])

export default __exports__